<template>
  <v-app id="dashboard">
    <!-- <AppBar /> -->
    <Drawer />
    <Content />
  </v-app>
</template>

<script>
// import AppBar from "../components/core/AppBar";
import Drawer from "../components/core/Drawer";
import Content from "../components/core/Content";
export default {
  name: "DashBoard",
  components: {
    Drawer,
    Content,
    // AppBar
  },
  data: () => ({
    // expandOnHover: false
  })
};
</script>

<style>
</style>